export default function getBufferETAFlag() {
  return __BROWSER__ && window.__SE_ADDITIONAL_ETA_AB__
}
